<template>
  <!-- 菜单 -->
  <div class="menuBox">
    <!-- 头部 -->
    <swipeTop :isHome="isHome" :top_img="top_img" />
    <!-- 搜索框 -->
    <!-- <seachVue /> -->
    <div class="content">
      <div class="menuItem" v-for="(item, index) in menuList">
        <div class="parentMenu">{{ item.menuName }}</div>
        <div class="childBox">
          <div class="childItem" v-for="(item1, index1) in item.subMenuList">
            <div @click="brandIntroduction(item1.menuId)" class="childMenu">
              {{ item1.menuName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  <div class="menu">-->
  <!--    <toolbar></toolbar>-->
  <!--    <div class="tabbar">-->

  <!--      <div v-for="(item, index) in menuList" :key="item.id" class="Onemenu">-->
  <!--        <div-->
  <!--          class="nextMenu"-->
  <!--          :class="{ checkSty: checkInd == index }"-->
  <!--          id="next"-->
  <!--        >-->
  <!--          <div-->
  <!--            v-for="(item, index) in childMenuList.subMenuList"-->
  <!--            :key="index"-->
  <!--            @click="brandIntroduction(item.menuId)"-->
  <!--          >-->
  <!--            {{ item.menuName }}-->
  <!--          </div>-->
  <!--        </div>-->
  <!--        <div @click="showChild(item, index)" class="oneName">-->
  <!--          {{ item.menuName }}-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->
</template>

<script>
import swipeTop from "@/components/swipeTop.vue";
import seachVue from "@/components/seachVue.vue";
import { homemenu, menuid } from "@/api/path";
import toolbar from "@/components/toolbar.vue";
import top_img from "@/assets/img/menu-img.png";

export default {
  data() {
    return {
      menuList: [],
      checkInd: -1,
      childMenuList: [],
      isShow: false,
      top_img: top_img,
      isHome: true,
    };
  },
  components: {
    toolbar,
    swipeTop,
    seachVue,
  },
  created() {
    this.getAllMenu();
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.backButton, false);
    }
  },
  methods: {
    showChild(item, index) {
      this.isShow = false;
      this.checkInd = index;
      menuid(item.menuId)
        .then((res) => {
          this.childMenuList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSelect(action) {
      Toast(action.text);
    },
    // 子品牌介绍
    brandIntroduction(mid) {
      let query = {
        mid: mid,
      };
      switch (mid) {
        case 9: // 应用服务 /levelThreePage?menuId=36
          this.$router.push({
            path: "/levelThreePage",
            query: { menuId: 36 },
          });
          break;
        case 10: // 资料中心
        case 11: // 文献指南
        case 12: // 在线课堂
        case 13: // 学术分享
          this.$router.push({ path: "/secondaryPages", query });
          break;
        case 7: // 应用领域
        case 8: // 产品介绍
          this.$router.push({ path: "/secondaryPagesYYLY", query });
          break;
        case 4: // 品牌介绍
          this.$router.push({ path: "/secondaryPagesPPJS", query });
          break;
        case 5: // 活动信息
          this.$router.push({ path: "/secondaryPagesHDXX", query });
          break;
        case 6: // 联系我们
          this.$router.push({ path: "/secondaryPagesLXWM", query });
          break;
        default:
          console.log("NOT FOUNT");
      }
    },
    getAllMenu() {
      homemenu().then((res) => {
        this.menuList = res.data;
      });
    },
    // 返回事件处理
    backButton() {
      history.pushState(null, null, document.URL);
    },
  },
  destroyed() {
    // 销毁页面返回事件
    window.removeEventListener("popstate", this.backButton, false);
  },
};
</script>

<style lang="scss" scoped>
.menuBox {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .content {
    flex: 1;
    background-image: url("../../assets/img/menuBg.png");
    background-size: 100% 100%;
    text-align: center;
    .menuItem {
      margin-top: 40px;
    }
    .parentMenu {
      width: 90%;
      background-color: white;
      margin: 0 auto;
      padding: 20px 0;
      font-size: 26px;
      font-family: LTZH, serif;
      letter-spacing: 2px;
      color: #e71a26;
      font-weight: bolder;
      border-radius: 15px;
    }
    .childBox {
      width: 88%;
      display: flex;
      margin: 0 auto;
      justify-content: space-between;
      .childItem {
        background-color: #a53d40;
        width: 33%;
        font-family: LTXH, serif;
        border-radius: 8px;
        margin: 10px 0;
        .childMenu {
          font-size: 28px;
          letter-spacing: 2px;
          padding: 10px 30px;
          color: white;
        }
      }
    }
  }
}
</style>
